import idleQueueService from './IdleQueueService';

export default class UserRecordingService {
  static async init() {
    if ((window.serverData?.requestCountry === 'AU' || window.serverData?.requestCountry === 'GB') && (window.location.href.includes('/signup') || window.location.href.includes('/admin'))) {
      const LogRocketService = (await import('./LogRocketService')).default;
      idleQueueService.addBgTask(LogRocketService.init);
    }
  }
}
